module.exports = __webpack_public_path__ + "assets/img/jianyan.e324d752.png";